import {
  delay,
  call,
  select,
  takeEvery,
  takeLatest,
  put,
  all,
  fork,
} from 'redux-saga/effects';
import * as sagasCommon from '../sagasCommon';
import * as api from '../../services/order_group/api_order_group';
import * as apiCommon from '../../services/apiCommon';
import * as docTypes from '../../constants/constant_doc_types';
import * as sagaTypes from '../../constants/constant_saga_types';

export default function* (app) {
  try {
    yield all([
      fork(fetchListOrderGroupSaga, app),
      fork(saveOrderGroupSaga, app),
      fork(deleteOrderGroupSaga, app),
      fork(fetchOrderGroupByIdSaga, app),
    ]);
  } catch (e) {
    console.error('@saga_order_group: ', e.message || e.stack);
    throw e;
  }
}

function* callFetchListOrderGroup(app, action) {
  try {
    const { silent, filters } = action;
    yield sagasCommon.showProgressListTable(silent);

    const dataParams = {
      filters,
      list_type: docTypes.ORDER_GROUP,
    };
    const tableData = yield call(apiCommon.getDocs, app, dataParams);
    yield call(sagasCommon.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (e) {
    yield sagasCommon.showErrorListTable(e);
  }
}

function* fetchListOrderGroupSaga(app) {
  yield takeLatest('FETCH_LIST_ORDER_GROUP', callFetchListOrderGroup, app);
}

function* callSaveOrderGroup(app, action) {
  try {
    yield sagasCommon.showProgressSaveRecord();
    const { tenant, user } = yield select();

    const params = { tenant, user, data: action.data };
    const result = yield call(api.saveDoc, app, params);
    yield sagasCommon.doneSaveRecord(result, 'Order group was saved');
    yield put({
      type: sagaTypes.SIMPLE_FORM_SET_DATA,
      data: result,
    });
    yield callFetchListOrderGroup(app, { silent: true });
  } catch (e) {
    yield sagasCommon.showErrorSaveRecord(e);
  }
}

function* saveOrderGroupSaga(app) {
  yield takeLatest('SAVE_ORDER_GROUP', callSaveOrderGroup, app);
}

export function* callDeleteOrderGroup(app, action) {
  try {
    yield sagasCommon.showProgressDeleteRecord();
    const { tenant, user } = yield select();
    const { id } = action;

    const params = { tenant, user, id };
    yield call(api.deleteDoc, app, params);
    yield sagasCommon.doneDeleteRecord(id, docTypes.ORDER_GROUP);
    yield delay(2000);
    yield callFetchListOrderGroup(app, { silent: true });
  } catch (e) {
    yield sagasCommon.showErrorDeleteRecord(e);
  }
}

function* deleteOrderGroupSaga(app) {
  yield takeLatest('DELETE_ORDER_GROUP', callDeleteOrderGroup, app);
}

function* callFetchOrderGroupById(app, action) {
  try {
    yield sagasCommon.showProgressDataById();
    const { tenant, user } = yield select();
    const { id } = action;

    const params = { tenant, user, id };
    const result = yield call(api.fetchDocById, app, params);
    yield sagasCommon.doneDataById(result);
    yield put({
      type: sagaTypes.SIMPLE_FORM_SET_DATA,
      data: result,
    });
  } catch (e) {}
}

function* fetchOrderGroupByIdSaga(app) {
  yield takeEvery('FETCH_ORDER_GROUP', callFetchOrderGroupById, app);
}
